import { useMutation, useQuery } from "react-query";
import * as zone from "services/configuration/zone/zone";

export const useZoneList = () => {
  return useMutation((formData) => zone.getZoneList(formData));
};

export const useAddZone = () => {
  return useMutation((formData) => zone.addZone(formData));
};

export const useEditZone = () => {
  return useMutation((formData) => zone.editZone(formData));
};

export const useDeleteZone = () => {
  return useMutation((formData) => zone.deleteZone(formData));
};

export const useStatusSite = () => {
    return useMutation((formData) => zone.statusSite(formData));
  };

export const useZoneDropdown = () => {
  return useQuery("zoneDropdown", () => zone.getZoneDropdown(), {
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};

export const useZoneEditDropdown = (id) => {
  return useQuery(["zoneEditDropdown", id], () => zone.getZoneEditDropdown(id),
    {
      retry: false,
      enabled: false,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    }
  );
};
export const useLocationDropdown = (id) => {
  return useQuery(["locationDropdown", id], () => zone.getLocationDropdown(id),
    {
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    }
  );
};
export const useSiteDropdown = () => {
  return useQuery("siteDropdown", () => zone.getSiteDropdown(), {
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};